import * as React from "react";
import { NavLink } from "react-router-dom";
import { withTranslation, WithTranslation } from "react-i18next";
import Axios, { AxiosResponse } from "axios";
import config from "../config";
import CoreComponent from "../pages/CoreComponent";
import { t } from "i18next";
import { IHolder, ICountry } from "../interfaces";
import { Formik } from 'formik';
import * as Yup from 'yup';
import { arrayToFormData } from '../utils/functions';
import { toast } from "react-toastify";

interface IProps extends WithTranslation {
    isOpen: boolean,
    producer_id: number,
    handleModal: any
}

interface IState {
    holders: {full_name:string, user_id: number}[],
    isLoading: boolean
}

class ProducersHolderModal extends CoreComponent<IProps, IState> {
    state: IState = {
        holders: [],
        isLoading: false
    }

    async componentWillMount() {
        let response: AxiosResponse = await Axios.get(`${config.api}/user/list`);

        if (!this.isUnmounted) {
            this.setState({
                holders: response.data
            });
        }
    }

    async handleSubmit(data: any, setErrors: any) {
        let { t } = this.props;

        let formData = arrayToFormData(data);

        if (!this.isUnmounted) {
            this.setState({
                isLoading: true,
            }, async () => {
                let response: any;

                response = await Axios.post(`${config.api}/producer/add-artist`, formData);

                if (response.data.status == "error") {
                    toast(response.data.message, {type: "error"});
                    this.setState({
                        isLoading: false
                    });

                    this.props.handleModal();
                } else {
                    if (!this.isUnmounted) {
                        toast(t("Правообладатель добавлен."), {type: "success"});
                        this.setState({
                            isLoading: false
                        });

                        this.props.handleModal();
                    }
                }
            });
        }
    }

    render() {
        let initialValues:any = {
            producer_id: this.props.producer_id,
            user_id: "",
        }

        let { t } = this.props;

        return (
            <div className={"popup " + (this.props.isOpen ? "d-flex" : "")}>
                <div className="popup__content" style={{height: "auto"}}>
                    <img onClick={() => this.props.handleModal()} src="img/Icon ionic-md-add.png" alt="" className="popup-del" />
                    <h1 className="popup__title">Добавление правообладателя</h1>
                    <Formik
                        enableReinitialize={true}

                        initialValues={initialValues}
                        onSubmit={async (values, { setErrors }) => {
                            await this.handleSubmit(values, setErrors);
                        }}

                        validationSchema={Yup.object().shape({
                            producer_id: Yup.number().required(),
                            user_id: Yup.number().required(),
                        })}
                    >
                        {(props) => {
                            const {
                                values,
                                errors,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                touched,
                                setFieldValue,
                                setFieldTouched
                            } = props;

                            return (
                                <form id="official-signup" onSubmit={handleSubmit}>
                                    <div className="popup__items">
                                        <div className="popup__item">
                                            <span>Правообладатели</span>
                                            <div className="form-location">
                                                <select name="user_id" value={values.user_id} onChange={handleChange} onBlur={handleBlur} className={(touched.user_id && errors.user_id ? "required" : "")}>
                                                    <option value="">Выберите правообладателя...</option>
                                                    {this.state.holders.map((holder: {full_name: string, user_id: number}, i: number) => {
                                                        return (
                                                            <option value={holder.user_id} key={i}>{holder.full_name}</option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="popup__item">
                                            <div className="form-log">
                                                <button type="submit">
                                                    {this.state.isLoading ? (
                                                        <i className="fa fa-spinner fa-2x rotating "></i>
                                                    ) : t("Добавить")}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            );
                        }}
                    </Formik>

                </div>
            </div>
        );
    }
}

export default withTranslation()(ProducersHolderModal);